/* eslint-disable no-useless-escape */
export const bookingTypes = {
    title: 'Erklärung der Buchungs-Optionen für Ihre Onlinetickets',
    description: `Als Standard-Buchungsoption ist die Ticketbuchung auf Keycards („Keycard“) aktiviert. Optional können Unternehmen mit <bold>SKIDATA-Zutrittssystem</bold> ihren Gästen hier weitere Buchungsoptionen aktivieren. <bold>Bitte stellen Sie vorab sicher, dass die technischen Voraussetzungen gegeben sind und dass auch alle Kassa-Mitarbeiter über ggf. anfallende Aufgaben</bold> (Ticket Erstellungen / Versand etc.) <bold>informiert sind!</bold>`,
    columns: [
        {
            title: 'KeyCard:',
            description:
                'Ticketbuchung auf eine starjack Keycard oder manuell registrierte Keycard* (*nur bei SKIDATAZutrittssystemen möglich). Vom Gast neu bestellte Keycards werden automatisch von starjack erstellt und versandt. Beim Erstzutritt wird die Berechtigung auf die Karte geladen. ',
        },
        {
            title: 'e-Ticket (für Zutrittsgates mit QR-Code- oder Barcode-Reader)',
            description:
                'Aktivieren Sie die Option nur, wenn Ihre Zutrittsgates mit QR-Code Reader oder Barcode-Reader ausgestattet sind. Ein e-Ticket befähigt den Gast zum direkten Zugang. Der Gast erhält die Zugangscodes per E-Mail, inkl. Download als PDF-Ticket*. Keine Keycard zur Buchung notwendig. *Das PDF kann mit Ihren Informationen und Grafiken individuell gestaltet werden. ',
        },
        {
            title: 'Pick-up-Voucher (Ticketabholung am Automaten oder Kassa):',
            description: `
                    Gast erhält per E-Mail einen QR-Code zur Ticketabholung an Ihrer Kassa oder, falls vorhanden, am
                    SKIDATA-Automaten. Voucher kann vom Gast als PDF* heruntergeladen werden. Pfandgebühren
                    können Sie optional bei starjack hinterlegen, diese werden dem Gast bei der Buchung direkt
                    abgerechnet.
                    * Ihre Kassa muss mit der SKIDATA ´print & send\` Software ausgestattet sein. Optional
                    können Handscanner für das schnellere Lesen des Codes und Ausstellen der Tickets an der
                    Kassa gekoppelt werden. Zutrittstickets müssen von Ihrem Kassapersonal bei Aktivierung
                    dieser Option ausgestellt werden können.
                    * Kompatibilität Ihrer Pick-up-Automaten bitte vorab bei SKIDATA anfragen und eine
                    Testbuchung durchführen!
                    
                    \* Das PDF kann mit Ihren Informationen und Grafiken individuell gestaltet werden.
                `,
        },
        {
            title: 'Produktion & Versand durch Bergbahn:',
            description: `
                Vom Gast neu bestellte Keycards werden von Ihrem Unternehmen erstellt und an den Gast
                versendet. Pfand- und Versandgebühren können Sie optional bei starjack hinterlegen, diese
                werden dem Gast bei der Buchung direkt abgerechnet
                * Die Buchungen gehen in Ihrem SKIDATA System als Reservierung ein. Sie benötigen eine
                SKIDATA „APS-Kasse“, um diese verarbeiten zu können.`,
        },
    ],
};

export const checkBoxTranslationsMap = {
    keycard: 'keycard',
    barcode: 'barcode',
    pickup: 'pickupOrder',
    internalProduction: 'internalProductionOrder',
    mobileFlow: 'mobileFlow',
};
